import { RecurrenceSettingsAction, RecurrenceSettingsState } from '../../types'
import { updateRecurrenceDate } from './stateTransitions/updateRecurrenceDate'
import { updateRecurrenceEnd } from './stateTransitions/updateRecurrenceEnd'
import { updateRecurrencePeriod } from './stateTransitions/updateRecurrencePeriod'
import { updateRecurrenceType } from './stateTransitions/updateRecurrenceType'
import { updateRecurrenceWhen } from './stateTransitions/updateRecurrenceWhen'

export function recurrenceSettingsReducer(
  state: RecurrenceSettingsState,
  action: RecurrenceSettingsAction,
): RecurrenceSettingsState {
  switch (action.type) {
    case 'recurrenceType:change': {
      return {
        ...updateRecurrenceType(state, action.recurrencePeriodType),
        isUpdatingFromProps: false,
      }
    }

    case 'recurrenceDate:change': {
      return {
        ...updateRecurrenceDate(state, action.recurrenceDate),
        isUpdatingFromProps: false,
      }
    }

    case 'recurrencePeriod:change': {
      return {
        ...updateRecurrencePeriod(state, action.recurrencePeriod),
        isUpdatingFromProps: false,
      }
    }

    case 'recurrenceWhen:change': {
      return {
        ...updateRecurrenceWhen(state, action.recurrenceWhen, action.calendarConfig),
        isUpdatingFromProps: false,
      }
    }

    case 'recurrenceEnd:change': {
      return {
        ...updateRecurrenceEnd(state, action.recurrenceEnd),
        isUpdatingFromProps: false,
      }
    }

    case 'forceUpdate': {
      return {
        ...state,
        value: action.value,
        // indicate that the state is being updated from props
        isUpdatingFromProps: true,
      }
    }
  }
}
